import { useQuery } from "@apollo/client/react";
import { Box } from "@repo/components/src/ui/box";
import { Heading } from "@repo/components/src/ui/heading";
import { Image } from "@repo/components/src/ui/image";
import { Text } from "@repo/components/src/ui/text";
import { formatMoneyFromFragment } from "@repo/components/src/utils/money";
import { GetProductSelectionDocument } from "@repo/graphql/documents/product/query.generated";
import React from "react";

type Props = {
  productId: string;
  index: number;
};

const ProductProfile = React.memo((props: Props) => {
  const { productId, index } = props;
  const { data } = useQuery(GetProductSelectionDocument, {
    variables: {
      id: productId,
    },
  });
  const product = data?.product.get;
  const image = product?.image;
  return (
    <Box>
      <Heading size="sm">{index + 1}. Sobre el producto</Heading>
      <Text bold size="sm">
        {product?.name}
      </Text>
      <Text size="sm" className="mt-2">
        {product?.description}
      </Text>
      <Text size="sm" className="mt-2">
        El precio de referencia son {formatMoneyFromFragment(product?.price)}
      </Text>
      {!!image && (
        <Image
          size="full"
          className="w-full h-56 mt-3 rounded-3xl"
          contentFit="cover"
          source={image?.url}
          alt={`Imágen ${product?.name}`}
        />
      )}
    </Box>
  );
});

ProductProfile.displayName = "ProductProfile";

export default ProductProfile;
